export default function slider($) {

    // $(".our--team-cards").slick({
    //     slidesToShow: 5.2,
    //     slidesToScroll: 1,
    //     arrows: true,
    //     dots: true,
    //     infinite: false,
    //     rows: 0,
    //     prevArrow: $(`.our--team .nhlp-left-arrow`),
    //     nextArrow: $(`.our--team .nhlp-right-arrow`),
    //     appendDots: $(`.our--team .our--team-dots`),
    //     responsive: [
    //         {
    //             breakpoint: 9999,
    //             settings: "unslick",
    //         },
    //         {
    //             breakpoint: 1025,
    //             settings: {
    //                 slidesToShow: 2.2,
    //             },
    //         },
    //         {
    //             breakpoint: 768,
    //             settings: {
    //                 slidesToShow: 1.2,
    //             },
    //         },
    //     ],
    // });

    $(".experts--wrap-cards").slick({
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        infinite: false,
        rows: 0,
        prevArrow: $(`.experts--wrap .nhlp-left-arrow`),
        nextArrow: $(`.experts--wrap .nhlp-right-arrow`),
        appendDots: $(`.experts--wrap .experts--wrap-dots`),
        responsive: [
            {
                breakpoint: 9999,
                settings: "unslick",
            },
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });

    $(".exceptional--care-cards").slick({
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        infinite: false,
        rows: 0,
        prevArrow: $(`.exceptional--care .nhlp-left-arrow`),
        nextArrow: $(`.exceptional--care .nhlp-right-arrow`),
        appendDots: $(`.exceptional--care .exceptional--care-dots`),
        responsive: [
            {
                breakpoint: 9999,
                settings: "unslick",
            },
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });

    $(".testimonial--wrap-cards").slick({

        slidesToScroll: 1,
        arrows: true,
        dots: true,
        infinite: false,
        rows: 0,
        prevArrow: $(`.testimonial--wrap .nhlp-left-arrow`),
        nextArrow: $(`.testimonial--wrap .nhlp-right-arrow`),
        appendDots: $(`.testimonial--wrap .testimonial--wrap-dots`),
        responsive: [
            {
                breakpoint: 9999,
                settings: "unslick",
            },
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                },
            },
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                },
            },
        ],
    });
}